module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bodyText",
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-img"
  }, [_c('img', {
    staticStyle: {
      "height": "1.2rem"
    },
    attrs: {
      "src": require("../assets/image/bottom.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bcb0232"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base.vue
// module id = 232
// module chunks = 1